// Detección de capacidad del dispositivo con Web APIs estándar.
//
// navigator.deviceMemory — W3C Device Memory API
//   Disponible en Chrome 63+ / Android WebView 63+ (el handheld Android 10 tiene WebView 80+).
//   Devuelve la RAM total del dispositivo redondeada a la potencia de 2 más cercana:
//   0.25 / 0.5 / 1 / 2 / 4 / 8
//   Si no está disponible (desktop, iOS <17), devuelve undefined → asumimos tier 'high'.
//
// Tiers definidos:
//   low    ≤ 2 GB  — handhelds Android 10, tablets de gama baja
//   medium  3-4 GB — OPPO CPH2387, gama media
//   high   ≥ 6 GB  — dispositivos de desarrollo, gama alta
//
// skipPhotoEditor — activo para tier 'low'. En OccurrenceItemAddonDialog y FieldUploadEditPicture
// omite el montaje de Fabric.js/PhotoEditor y guarda la imagen directo.
// En componentes de tarea (Task, TaskAssign, etc.) pendiente — sus métodos de
// upload no son Blob-aware todavía.

export const TIER_CONFIG = {
  low: {
    quality: 70,            // camera.getPicture quality (0–100)
    targetWidth: 1024,      // límite de resolución en cámara nativa (px) — debe ir junto con targetHeight (requisito del plugin)
    targetHeight: 1024,
    compressQuality: 0.7,   // calidad JPEG en compressImage (0.0–1.0)
    skipPhotoEditor: true   // activo: tier low omite PhotoEditor para evitar OOM
  },
  medium: {
    quality: 80,
    targetWidth: 1280,
    targetHeight: 1280,
    compressQuality: 0.8,
    skipPhotoEditor: false
  },
  high: {
    quality: 90,
    targetWidth: 1500,
    targetHeight: 1500,
    compressQuality: 0.85,
    skipPhotoEditor: false
  }
}

let _cachedTier = null

export function getDeviceTier () {
  if (_cachedTier) return _cachedTier
  const ram = navigator.deviceMemory ?? 8
  if (ram <= 2) _cachedTier = 'low'
  else if (ram <= 4) _cachedTier = 'medium'
  else _cachedTier = 'high'
  return _cachedTier
}

export function getDeviceInfo () {
  return {
    ram: navigator.deviceMemory ?? null,
    cores: navigator.hardwareConcurrency ?? null,
    tier: getDeviceTier()
  }
}

// Tiers low y medium son candidatos a kill del LMK durante la captura de cámara
// nativa (ver investigación crash Casa Ley 2GB Android 10 y Oppo CPH2387 4GB).
// high queda fuera: sin reportes de crash, margen de RAM real.
export function shouldElevatePriority () {
  return getDeviceTier() !== 'high'
}

